export var source = "mutation RateProduct($input: RateProductInput!) {\n  rateProduct(input: $input) {\n    result\n    errors {\n      ...GqlError\n    }\n  }\n}";
import { source as fragment1 } from "../../../../../helpers/fragments/gqlError.graphql";
var combined = source  + "\n" + fragment1;
export default combined;